import cn from 'clsx'

import CircleSpinner from '@components/shared/CircleSpinner'
import DocumentSearchResultsTable from './DocumentSearchResultsTable'
import Pagination from '@components/shared/Pagination'
import TableHeaderManager from '@/components/shared/TableHeaderManager/TableHeaderManager'
import { HIDE_COL_ON_INDEX, SEARCH_HEADERS } from '@/constants'

const CollectionSearchResultsView = ({ vm }) => (
    <>
        <div
            id="CollectionSearchResultsView"
            style={{ height: '44px' }}
            className="
                flex items-center justify-between text-nowrap px-3
                sticky top-[0] left-[0] bg-base-100">
            <div>
                <div className="text-base">Found {vm.documents?.count ?? '0'} Results</div>
                <div className="text-sm w-[142px]">
                    Total: {vm.documents?.rows?.length ?? '0'} /
                    {' '}
                    Selected: {vm.markedDocuments.length}
                </div>
            </div>
            {vm.documents?.count > vm.searchResultsPerPage && 
            <Pagination
                count={vm.documents?.count}
                itemsPerPage={vm.searchResultsPerPage}
                forcePage={vm.pageIndex} // this is necessary to reset page when a search happens
                setPageIndex={vm.setPageIndex}
                pageRangeDisplayed={5} />}
            
            <TableHeaderManager
                storeName="documentHeaders"
                headers={SEARCH_HEADERS.filter(sh => !HIDE_COL_ON_INDEX.includes(sh.id))} />
        </div>
        <div style={{ height: 'auto' }}>
            <div className={cn('justify-center flex my-6 text-muted', { hidden: !vm.loading })}>
                <div>Searching...</div>
                <CircleSpinner className="ml-4 flex" />
            </div>
            
            <div className={cn('flex justify-center my-6 text-muted', {
                hidden: vm.loading || vm.documents?.rows?.length,
            })}>
                <div>No search results found.</div>
            </div>
            
            {!vm.loading && !!vm.documents?.rows?.length && <DocumentSearchResultsTable
                documents={vm.documents?.rows ?? []}
                markedDocuments={vm.markedDocuments}
                setMarkedDocuments={vm.setMarkedDocuments} />}
        </div>
    </>
    
)

export default CollectionSearchResultsView
